// extracted by mini-css-extract-plugin
export var container = "_qw-0";
export var dotAnimation = "_qw-2";
export var dotsLoading = "_qw-1";